import React from 'react';
import PropTypes from 'prop-types';
import { Button, Tooltip } from 'antd';
import { getIcon, getStyleDisabled } from './Button';
import * as S from './styles';
import * as Styles from 'components/Style';

export const ComponentButtonDefault = ({
  text,
  clickAction,
  buttonType,
  disabled = false,
  outline,
  iconDirection = 'left',
  color = 'blue',
  type = 'primary',
  css,
  icon,
  loading,
  messageTooltip = null,
  ...rest
}) => {
  return (
    <Styles.GlobalButtonContain
      display={css?.display}
      flexDirection={css?.flexDirection}
      alignItems={css?.alignItems}
      corSecundaria={css?.corSecundaria}
      cor={css?.cor}
      justifyContent={css?.justifyContent}
    >
      <S.ButtonContain
        color={color}
        outline={outline}
        iconDirection={iconDirection}
        buttonType={buttonType}
        margin={css?.margin}
      >
        <Button
          style={getStyleDisabled(disabled)}
          type={type}
          size={'large'}
          icon={getIcon(text)}
          onClick={() => clickAction()}
          disabled={disabled}
          data-testid={`buttonDefault-${text}`}
          loading={loading}
          {...rest}
        >
          {messageTooltip ? (
            <Tooltip placement="bottom" title={messageTooltip}>
              {text}
              {icon}
            </Tooltip>
          ) : (
            <>
              {text}
              {icon}
            </>
          )}
        </Button>
      </S.ButtonContain>
    </Styles.GlobalButtonContain>
  );
};

ComponentButtonDefault.propTypes = {
  text: PropTypes.string,
  clickAction: PropTypes.func,
  buttonType: PropTypes.string,
  disabled: PropTypes.bool,
  outline: PropTypes.bool,
  iconDirection: PropTypes.string,
  color: PropTypes.string,
  type: PropTypes.string,
  css: PropTypes.object,
  icon: PropTypes.element,
  loading: PropTypes.bool,
  messageTooltip: PropTypes.string,
};

ComponentButtonDefault.defaultProps = {
  // text: '',
  // clickAction: functionMock,
  // buttonType: '',
  // disabled: false,
  // outline: false,
  // iconDirection: 'left',
  // color: 'blue',
  // type: 'primary',
  // css: {},
  // icon: null,
  // loading: false,
};

export default ComponentButtonDefault;
